<template>
  <div class="basicInfo common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('general.BasicInfo') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('approvalCenter.ActivityNumber') }}</div>
            <div class="text">{{ basicData.activityCode }}</div>
          </div>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.fs') }}</div>
            <div class="text">{{ basicData.financialSystemName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.toc') }}</div>
            <div class="text">{{ basicData.currencyType }}</div>
          </div>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.Applicant') }}</div>
            <div class="text">{{ basicData.userData }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.ci') }}</div>
            <div class="text">{{ basicData.applyUserTel }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.at') }}</div>
            <div class="text">{{ basicData.applyTime }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.cs') }}</div>
            <div class="text">{{ basicData.saler }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      basicData: {}
    };
  },
  mounted () {
    this.basicData = this.echoData.marketActivity;
    this.basicData.userData = `${this.basicData.applyUserName} / ${this.basicData.applyUserDeptName}`;
    this.basicData.saler = `${this.basicData.salerName} / ${this.basicData.salerDeptName}`;
  }
};
</script>

<style scoped>

</style>
